export default __webpack_public_path__ + "static/media/partner (9).18efc46c.png";